import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Skeleton,
  Breadcrumbs
} from '@mui/material';

const EstimateDetailSkeleton: React.FC = () => {
  return (
    <Box>
      {/* Breadcrumbs Skeleton */}
      <Breadcrumbs sx={{ mb: 2 }}>
        <Skeleton variant="text" width={80} />
        <Skeleton variant="text" width={100} />
        <Skeleton variant="text" width={120} />
      </Breadcrumbs>

      {/* Header Skeleton */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Box display="flex" alignItems="center" gap={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box>
            <Skeleton variant="text" width={200} height={32} />
            <Box display="flex" alignItems="center" gap={2} mt={1}>
              <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 4 }} />
              <Skeleton variant="rectangular" width={100} height={24} sx={{ borderRadius: 4 }} />
            </Box>
          </Box>
        </Box>
        
        <Box display="flex" gap={1}>
          <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" width={120} height={36} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" width={140} height={36} sx={{ borderRadius: 1 }} />
          <Skeleton variant="circular" width={40} height={40} />
        </Box>
      </Box>

      <Grid container spacing={3}>
        {/* Estimate Information Skeleton */}
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Skeleton variant="text" width={150} height={24} sx={{ mb: 2 }} />
              
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Skeleton variant="text" width={100} height={16} />
                  <Skeleton variant="text" width={120} height={20} />
                </Grid>
                
                <Grid item xs={6}>
                  <Skeleton variant="text" width={80} height={16} />
                  <Skeleton variant="text" width={120} height={20} />
                </Grid>
                
                <Grid item xs={12}>
                  <Skeleton variant="text" width={80} height={16} />
                  <Skeleton variant="text" width={200} height={20} />
                </Grid>
                
                <Grid item xs={12}>
                  <Skeleton variant="text" width={60} height={16} />
                  <Skeleton variant="rectangular" width="100%" height={60} />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Summary Skeleton */}
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Skeleton variant="text" width={80} height={24} sx={{ mb: 2 }} />
              
              {[1, 2, 3].map((item) => (
                <Box key={item} display="flex" justifyContent="space-between" mb={1}>
                  <Skeleton variant="text" width={80} />
                  <Skeleton variant="text" width={100} />
                </Box>
              ))}
              
              <Box sx={{ my: 1 }}>
                <Skeleton variant="rectangular" width="100%" height={1} />
              </Box>
              
              <Box display="flex" justifyContent="space-between">
                <Skeleton variant="text" width={60} height={24} />
                <Skeleton variant="text" width={120} height={24} />
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Line Items Skeleton */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Skeleton variant="text" width={100} height={24} sx={{ mb: 2 }} />
              
              {/* Table Header */}
              <Box display="flex" gap={2} mb={2}>
                <Skeleton variant="text" width={150} />
                <Skeleton variant="text" width={80} />
                <Skeleton variant="text" width={100} />
                <Skeleton variant="text" width={80} />
                <Skeleton variant="text" width={80} />
                <Skeleton variant="text" width={100} />
              </Box>
              
              {/* Table Rows */}
              {[1, 2, 3].map((row) => (
                <Box key={row} display="flex" gap={2} mb={1}>
                  <Skeleton variant="text" width={150} />
                  <Skeleton variant="text" width={80} />
                  <Skeleton variant="text" width={100} />
                  <Skeleton variant="text" width={80} />
                  <Skeleton variant="text" width={80} />
                  <Skeleton variant="text" width={100} />
                </Box>
              ))}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EstimateDetailSkeleton;